import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, ShieldCheck } from 'lucide-react';
import { solutionSettings } from '../../data/solutions';
import { fadeUp } from '../../utils/motion';
export function SolutionSettings() {
  const scrollTo = (id: string) => (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    document.getElementById(id)?.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  };
  return <section className="bg-white py-20 lg:py-28" data-id="element-1605" data-mp="35wbz0df1qls9">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16" data-id="element-1606" data-mp="3aon1no168loi">
        <nav aria-label="Solution settings" className="hidden lg:block lg:col-span-3" data-id="element-1607" data-mp="2w0ifga2wts0z">
          <div className="sticky top-28" data-id="element-1608" data-mp="30xsg6lvr1q44">
            <p className="text-sm font-medium text-ink-muted mb-4" data-id="element-1609" data-mp="30yttkx08mop0">Settings</p>
            <ul className="border-l border-line" data-id="element-1610" data-mp="2n03whhdf4p0n">
              {solutionSettings.map(item => <li key={item.id} data-id="element-1611" data-mp="2rxcdhemtyn0b">
                  <a href={`#${item.id}`} onClick={scrollTo(item.id)} className="block -ml-px border-l-2 border-transparent hover:border-navy pl-4 py-1.5 text-sm text-ink-muted hover:text-navy transition-colors duration-150" data-id="element-1612" data-mp="2rzosbixakh95">
                    {item.setting.replace('For ', '')}
                  </a>
                </li>)}
            </ul>
          </div>
        </nav>

        <div className="lg:col-span-9" data-id="element-1613" data-mp="1606fst0l8jgi">
          {solutionSettings.map(item => <motion.article key={item.id} id={item.id} {...fadeUp} className="scroll-mt-28 border-t border-line py-14 first:border-t-0 first:pt-0" data-id="element-1614" data-mp="111lib1cq0dvr">
              <ul aria-label="Supporting components" className="flex flex-wrap gap-2 mb-4" data-id="element-1615" data-mp="1ax55mzd7y48w">
                {item.planned && <li className="text-xs font-semibold text-navy bg-surface-muted border border-line rounded px-2 py-1 whitespace-nowrap" data-id="element-1616" data-mp="n6svdhui3vf5">
                    Planned
                  </li>}
                {item.components.map(component => <li key={component} className="text-xs font-medium text-teal border border-line rounded px-2 py-1 whitespace-nowrap" data-id="element-1617" data-mp="2n9ty88jnfhko">
                    {component}
                  </li>)}
              </ul>
              <h2 className="font-heading font-bold text-3xl lg:text-4xl text-ink-dark tracking-tight mb-3" data-id="element-1618" data-mp="1zera62so5i59">
                {item.setting}
              </h2>
              <p className="text-xl text-ink-dark mb-8" data-id="element-1619" data-mp="28ee0ntjv13jj">{item.tagline}</p>

              <div className="grid grid-cols-1 xl:grid-cols-12 gap-8 xl:gap-12" data-id="element-1620" data-mp="28g8nxeilt7qs">
                <div className="xl:col-span-8 space-y-5" data-id="element-1621" data-mp="2des7575tc5fg">
                  {item.paragraphs.map(paragraph => <p key={paragraph} className="text-lg text-ink-muted leading-relaxed" data-id="element-1622" data-mp="3jvdr0jmnd8ax">
                      {paragraph}
                    </p>)}
                  {item.safeguard && <div className="flex gap-4 bg-surface-muted rounded-lg p-5" data-id="element-1623" data-mp="2sri0s7rgv7o">
                      <ShieldCheck size={20} className="text-navy-light shrink-0 mt-1" aria-hidden="true" data-id="element-1624" data-mp="3tzazurc0llfh" />
                      <p className="text-ink-dark leading-relaxed" data-id="element-1625" data-mp="3p4530xh2qmcm">{item.safeguard}</p>
                    </div>}
                </div>

                <aside className="xl:col-span-4" data-id="element-1626" data-mp="3g6uq77olyp5l">
                  <h3 className="text-sm font-semibold text-ink-dark mb-3" data-id="element-1627" data-mp="3g3gqk77bwu1u">Possible applications</h3>
                  <ul className="border-t border-line mb-6" data-id="element-1628" data-mp="3b92xwck1x10v">
                    {item.applications.map(application => <li key={application} className="border-b border-line py-2.5 text-ink-muted" data-id="element-1629" data-mp="326jyk2fh56jd">
                        {application}
                      </li>)}
                  </ul>
                  <a href={item.link} className="inline-flex items-center gap-2 text-navy font-semibold hover:text-navy-light transition-colors duration-150 whitespace-nowrap" data-id="element-1630" data-mp="10efd99shd7hm">
                    {item.linkLabel}
                    <ArrowRight size={16} data-id="element-1631" data-mp="yhgz6jfzi9ql" />
                  </a>
                </aside>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}